import { CATEGORY_BY_ID } from '../categories';
import type { Registration } from '../registry';

const n = CATEGORY_BY_ID.motor.colour;

export const motorRegistration: Registration = {
  definitions: [
    {
      type: 'esp32_motor_setup',
      message0:
        'motor driver %1 IN1 %2 IN2 %3 IN3 %4 IN4 %5 ENA/PWMA %6 ENB/PWMB %7 STBY %8 (-1 if unused)',
      args0: [
        { type: 'field_dropdown', name: 'MODEL', options: [['L298N', 'L298N'], ['TB6612FNG', 'TB6612FNG'], ['DRV8833', 'DRV8833']] },
        { type: 'field_number', name: 'IN1', value: 25, min: 0, max: 48, precision: 1 },
        { type: 'field_number', name: 'IN2', value: 26, min: 0, max: 48, precision: 1 },
        { type: 'field_number', name: 'IN3', value: 27, min: 0, max: 48, precision: 1 },
        { type: 'field_number', name: 'IN4', value: 14, min: 0, max: 48, precision: 1 },
        { type: 'field_number', name: 'ENA', value: 32, min: -1, max: 48, precision: 1 },
        { type: 'field_number', name: 'ENB', value: 33, min: -1, max: 48, precision: 1 },
        { type: 'field_number', name: 'STBY', value: -1, min: -1, max: 48, precision: 1 },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: n,
      tooltip:
        'Configure a dual H-bridge driver. L298N uses IN1-4 + ENA/ENB; TB6612FNG uses IN1-4 + PWMA/PWMB (+STBY); DRV8833 has no enable pins (set ENA/ENB to -1), speed goes through IN1-4.',
    },
    {
      type: 'esp32_motor_run',
      message0: 'set motor %1 direction %2 speed %3 (0-255)',
      args0: [
        { type: 'field_dropdown', name: 'MOTOR', options: [['A', 'A'], ['B', 'B'], ['A + B', 'BOTH']] },
        { type: 'field_dropdown', name: 'DIR', options: [['forward', 'FORWARD'], ['backward', 'BACKWARD']] },
        { type: 'input_value', name: 'SPEED', check: 'Number' },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: n,
      tooltip: 'Drive one or both motors. Requires a "motor driver" setup block.',
    },
    {
      type: 'esp32_motor_stop',
      message0: 'stop motor %1',
      args0: [
        { type: 'field_dropdown', name: 'MOTOR', options: [['A', 'A'], ['B', 'B'], ['A + B', 'BOTH']] },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: n,
      tooltip: 'Stop one or both motors (speed 0).',
    },
  ],
  metas: [
    {
      type: 'esp32_motor_setup',
      category: 'motor',
      label: 'Motor driver setup',
      description: 'Configure a dual H-bridge motor driver (L298N, TB6612FNG or DRV8833). Put it in "when board starts". Use -1 for pins the driver does not have.',
      fields: {
        MODEL: { kind: 'dropdown', options: ['L298N', 'TB6612FNG', 'DRV8833'] },
        IN1: { kind: 'number' }, IN2: { kind: 'number' }, IN3: { kind: 'number' }, IN4: { kind: 'number' },
        ENA: { kind: 'number' }, ENB: { kind: 'number' }, STBY: { kind: 'number' },
      },
    },
    {
      type: 'esp32_motor_run',
      category: 'motor',
      label: 'Run motor',
      description: 'Drive motor A, B or both with a direction and speed (0-255).',
      fields: {
        MOTOR: { kind: 'dropdown', options: ['A', 'B', 'BOTH'] },
        DIR: { kind: 'dropdown', options: ['FORWARD', 'BACKWARD'] },
        SPEED: { kind: 'value', types: 'Number' },
      },
    },
    {
      type: 'esp32_motor_stop',
      category: 'motor',
      label: 'Stop motor',
      description: 'Stop motor A, B or both.',
      fields: { MOTOR: { kind: 'dropdown', options: ['A', 'B', 'BOTH'] } },
    },
  ],
};
